export default __webpack_public_path__ + "static/media/checklist.17134d7b.svg";